<template>
  <router-view/>
</template>

<script>
import store from '@/store/index'
import { onMounted } from 'vue'
import router from '@/router'
export default {
setup() {
  window.addEventListener('resize', function() {
    setRem()
    // handleScreen()
    // var whdef = 100 / 1920 // 表示1920的设计图,使用100PX的默认值
    // var wW = window.innerWidth // 当前窗口的宽度
    // var rem = wW * whdef // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
    // document.documentElement.style.fontSize = rem + 'px'
    })

    // 获取SSO需要的token
  const dats = location.href.indexOf('access_token')
  if(dats>0){
    const accessToken = location.href.split('=')[1].split('&token_type')[0]
    store.commit('saveAccessToken', accessToken)
  }

  const handleScreen = ()=>{
    const m = detectZoom();
    document.body.style.zoom = 100/Number(m);
  }

  const detectZoom = ()=>{
    let ratio = 0,
          screen = window.screen,
          ua = navigator.userAgent.toLowerCase();
        if (window.devicePixelRatio !== undefined) {
          ratio = window.devicePixelRatio;
        } else if (~ua.indexOf('msie')) {
          if (screen.deviceXDPI && screen.logicalXDPI) {
            ratio = screen.deviceXDPI / screen.logicalXDPI;
          }
        } else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
          ratio = window.outerWidth / window.innerWidth;
        }
        if (ratio) {
          ratio = Math.round(ratio * 100);
        }
        return ratio;
  }

  const setRem = ()=>{

    // 在标准 375px 适配下，100px = 1rem;
    var baseFontSize = 100; //转换的尺寸

    //设计师的尺寸
    var baseWidth = 1920;
    var baseHeight = 1080;

    //浏览器缩放比例
    var t = window.devicePixelRatio || 1;

    //获取当前视口宽高 （*t实际作用为解决笔记本缩放问题，获取的实际为当前设备的实际像素）
    const pcnumberW = (document.documentElement.clientWidth || window.innerWidth)
    const pcnumberH = (document.documentElement.clientHeight || window.innerHeight)

    const clientWidth = pcnumberW * t;
    const clientHeight = pcnumberH * t;
    if (!clientWidth || !clientHeight) return;
    //比较宽高 以更小的比例为准去适配
    var rem = 100;
    
    if(clientWidth<960){
      rem = 100;
      document.documentElement.style.fontSize = rem + 'px'
      document.documentElement.style.width = '1920px'
      document.documentElement.style.height = '1080px'
      return
    }

    if(clientWidth>=2048){
      rem = 100;
      document.documentElement.style.fontSize = rem + 'px'
      return
    }
    

    if (clientWidth <= baseWidth) {
      rem = (clientWidth / 1920) * baseFontSize;
    } else {
      rem = (clientHeight / 1080) * baseFontSize;
    }


    document.documentElement.style.width = '100%'
    document.documentElement.style.height = '100%'
    document.documentElement.style.fontSize = rem + 'px'
   

  }


  onMounted(()=>{
    setRem()
    // handleScreen()
    // var whdef = 100 / 1920 // 表示1920的设计图,使用100PX的默认值
    // var wW = window.innerWidth // 当前窗口的宽度
    // var rem = wW * whdef // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
    // document.documentElement.style.fontSize = rem + 'px'
  })
}
}
</script>

<style lang="scss">
#app {
// font-family: Avenir, Helvetica, Arial, sans-serif;
-webkit-font-smoothing: antialiased;
-moz-osx-font-smoothing: grayscale;
width: 100%;
height: 100%;
}

// nav {
//   padding: .3rem;

//   a {
//     font-weight: bold;
//     color: #2c3e50;

//     &.router-link-exact-active {
//       color: #42b983;
//     }
//   }
// }
</style>
<style src="@/common/style/elementStyle.css"></style>
